import * as origin from "@shopify/theme-cart";

export default () => ({
	product: null,
	product_url: null,
	selectedVariant: null,
	activeVariant: null,
	qty: 1,
	loading: false,
	addVariantToCart(id, quantity, properties = null) {
		console.log("addtocart.js: addVariantToCart()");
		this.loading = true;
		Alpine.store("shopify").cartLoading = true;
		origin
			.addItem(id, { quantity, properties })
			.then((res) => {
				console.log(
					"addtocart.js: SUCCESS addVariantToCart()",
					res.body
				);
				this.loading = false;
				Alpine.store("shopify").cartLoading = false;
				Alpine.store("shopify").reload();
				Alpine.store("shopify").toggleCart();
				console.log("addtocart.js: Variant added to cart: ", res);
			})
			.catch((err) => {
				console.log("addtocart.js: ERROR addVariantToCart()", err.body);
				this.loading = false;
				Alpine.store("shopify").cartLoading = false;
				Alpine.store("shopify").reload();
				console.log(
					"addtocart.js: Error adding variant to cart: ",
					err
				);
			});
	},
	switchVariant(variant) {
		// console.log("SWITCH VARIANT.... ", variant);
		if (this.product && variant != null) {
			this.selectedVariant = variant;
			this.activeVariant = this.product.variants.filter(
				(v) => v.id === variant
			)[0];
			// console.log("VARIANT SWITCHED");
		} else {
			// console.log("NOT YET, ", variant);
			this.selectedVariant = variant;
		}
	},
	init() {
		console.log("addtocart.js: init()");

		window.Alpine.effect(() => {
			this.switchVariant(this.selectedVariant);
		});
	},
});
